import { ApiResult, throwApiError } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { EEBusMiddlewareDto } from '../types'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'

/**
 * Fetch EEBus middleware info from EMC device.
 * @param installationId Installation ID
 * @param emcDeviceId  EMC Device ID
 * @param authFetch  AuthFetch function
 * @returns EEBusMiddlewareDto or null if not found
 */
export const getEebusInfoFromEmc = async (
  installationId: number,
  emcDeviceId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<EEBusMiddlewareDto | null>> => {
  try {
    const response = await authFetch<EEBusMiddlewareDto>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcDeviceId}/middlewares/eebus`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<EEBusMiddlewareDto>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get EEBus info from EMC:')
  }
}
